// extracted by mini-css-extract-plugin
module.exports = {"c-seo":"_025a50318d--c-seo--Ob5q3"};